"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEventAnalytic = void 0;
var react_1 = require("react");
var use_analytics_1 = require("./use-analytics");
function useEventAnalytic(dispatch, eventHandler) {
    var analytics = use_analytics_1.useAnalytics();
    var ref = react_1.useRef({ dispatch: dispatch, eventHandler: eventHandler });
    ref.current = { dispatch: dispatch, eventHandler: eventHandler };
    return react_1.useCallback(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _a = ref.current, dispatch = _a.dispatch, eventHandler = _a.eventHandler;
        dispatch.apply(void 0, __spreadArray([analytics.dispatcher], args));
        if (typeof eventHandler === 'function') {
            return eventHandler.apply(void 0, args);
        }
    }, [analytics]);
}
exports.useEventAnalytic = useEventAnalytic;
